import Abstract from "../../../abstract-view/abstract.js";

import {
  createElement,
  removeElement
} from "../../../render/render.js";

import {
  RESPONSIVE_FILTER_OPEN as RESPONSIVE_FILTER_OPEN_LEXICON
} from "../lexicon.js";

const createButtonTemplate = () => {
  return (
    `<button class="button button_responsive-filter-trigger" style="display: none;">${RESPONSIVE_FILTER_OPEN_LEXICON}</button>`
  );
};

const createStickyButtonTemplate = () => {
  return (
    `<button class="button button_responsive-filter-trigger button_responsive-filter-trigger_sticky" style="display: none;">
      <span class="visually-hidden">${RESPONSIVE_FILTER_OPEN_LEXICON}</span>
    </button>`
  )
};

export default class ResponsiveFilterButton extends Abstract {
  constructor() {
    super();

    this._stickyButtonElement = null;

    this._clickHandler = this._clickHandler.bind(this);
    this._stickyButtonClickHandler = this._stickyButtonClickHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getStickyButtonElement() {
    if (!this._stickyButtonElement) {
      this._stickyButtonElement = createElement(this._getStickyTemplate());
    }

    return this._stickyButtonElement;
  }

  removeStickyButton() {
    removeElement(this.getStickyButtonElement());
    this._stickyButtonElement = null;
  }

  setClickHandler(callback) {
    this._callback.click = callback;
    this._element.addEventListener(`click`, this._clickHandler);
  }

  setStickyButtonClickHandler(callback) {
    this._callback.stickyButtonClick = callback;
    this.getStickyButtonElement().addEventListener(`click`, this._stickyButtonClickHandler);
  }

  _getTemplate() {
    return createButtonTemplate();
  }

  _getStickyTemplate() {
    return createStickyButtonTemplate();
  }

  _clickHandler() {
    this._callback.click();
  }

  _stickyButtonClickHandler() {
    this._callback.stickyButtonClick();
  }
}
